import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { Icons } from '../../../atoms/SVG';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonIconActionDeclineSpecificProps = {
  text: string;
  type?: 'button' | 'submit' | 'reset';
  formAction?: string;
  href?: string;
  routing?: boolean;
  reference?: ButtonRefType;
  focusOnMount?: boolean;
  tooltipPlacement?: TooltipPlacement;
};

export type ButtonIconActionDeclineProps = SharedButtonProps & ButtonIconActionDeclineSpecificProps;

export function ButtonIconActionDecline({
  text,
  onClick,
  disabled,
  ariaDisabled,
  type = ariaDisabled ? 'button' : 'submit',
  ariaLabel,
  ariaDescribedBy,
  ariaControls,
  formAction,
  href,
  routing,
  reference,
  focusOnMount,
  tooltipPlacement,
  ...rest
}: ButtonIconActionDeclineProps) {
  return (
    <Btn
      {...rest}
      modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_NO]}
      text={text}
      svgSpriteId={Icons.DECLINE_CROSS}
      hiddenText
      onClick={onClick}
      disabled={disabled}
      ariaDisabled={ariaDisabled}
      type={type}
      titleText={text}
      ariaLabel={ariaLabel}
      ariaDescribedBy={ariaDescribedBy}
      ariaControls={ariaControls}
      formAction={formAction}
      href={href}
      routing={routing}
      reference={reference}
      focusOnMount={focusOnMount}
      tooltipPlacement={tooltipPlacement}
    />
  );
}
